export const MessageType = {
    OK : 1,
    ACCESSERROR : 2,
    ADVERTENCIA : 3,
    CONECTIONERROR: 4,
    PROCESSERROR: 5,
    COMPLETEDATA: 6,
    VALIDATEMAIL: 7,
    VALIDATECONFIRMMAIL: 8
}